import { BasePage } from '#src/components/BasePage/BasePage.tsx';

import { useLocation } from 'react-router';

import { PageErrorBoundary } from '#src/components/PageErrorBoundary/PageErrorBoundary.tsx';
import { ClientErrorPage } from './ClientErrorPage.tsx';
import { ContactForm } from './contactForm/contactForm.tsx';

const ContactPage = () => (
  <PageErrorBoundary errorPage={<ClientErrorPage />}>
    <BasePage
      title="Contact Form"
      breadcrumbs={[{ title: 'Docs', href: useLocation().pathname }]}
    >
      <ContactForm />
    </BasePage>
  </PageErrorBoundary>
);

export default () => <ContactPage />;
